import { ReportPage } from './ReportPage';

export function BenchReport() {
  return <ReportPage reportName="Bench report" />;
}
